import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "heading-box__ttl"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]

import { mapModifires, type typeModifires } from "@/components/utils/modifires";
import { withDefaults } from "vue";

interface Props {
  modifires?: typeModifires;
  title?: string;
  allSelectButton?: boolean;
  disabled?: boolean;
  noPadding?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'heading-box',
  props: {
    modifires: { type: [String, Array, Boolean] },
    title: {},
    allSelectButton: { type: Boolean },
    disabled: { type: Boolean },
    noPadding: { type: Boolean }
  },
  emits: ["selectAll", "resetAll"],
  setup(__props: any, { emit }) {

const props = __props;




const selectAll = () => {
  emit("selectAll");
};

const resetAll = () => {
  emit("resetAll");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(mapModifires)('heading-box', _ctx.modifires))
  }, [
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
          (_ctx.allSelectButton)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "all-select-button",
                disabled: _ctx.disabled,
                onClick: selectAll
              }, " 全選択 ", 8, _hoisted_2))
            : _createCommentVNode("", true),
          (_ctx.allSelectButton)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "all-select-button",
                disabled: _ctx.disabled,
                onClick: resetAll
              }, " 全解除 ", 8, _hoisted_3))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["heading-box__contents", { 'heading-box__contents_no_padding': _ctx.noPadding }])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ], 2))
}
}

})